module.exports = __webpack_public_path__ + "SourceSansPro-Bold.5e5c364166233f37ae9d.ttf";


//////////////////
// WEBPACK FOOTER
// C:/Users/jerd_/Documents/e-payment-public/e-payment-frontend/src/assets/customfonts/SourceSansPro-Bold.ttf
// module id = ../../../../../src/assets/customfonts/SourceSansPro-Bold.ttf
// module chunks = styles